import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-users',
  template: `
    <div
      [ngClass]="{
        wrapper: subscription === 'users',
        wrapperSub: subscription !== 'users'
      }"
    >
      <users-view *axLazyElement></users-view>
    </div>
  `,
  styleUrls: ['../../app.component.scss'],
})
export class UsersComponent implements OnInit {
  subscription: string = '';
  constructor() {
    this.subscription = window.location.pathname.split('/')[1];
  }

  ngOnInit(): void {}
}
